export default __webpack_public_path__ + "static/no-load-43dd9a18562f3deb3873b31fb85309a1.svg";